// @ts-ignore
import {Admin, Resource} from "react-admin";
import React, {useEffect} from "react";
import DataProviders from "./DataProviders";
import {EventCreate, PostIcon} from "./AdminEvents";
import {EventDetails, EventList} from "./events";
import EventResultCreate from "./events/results/EventResultCreate";
import {EventBasketingCreate} from "./events/basketing/EventBasketingCreate";
import {authProvider} from "./authProvider";
import {LiveVideoList} from "./LiveVideo/LiveVideoList";
import {LivelookupEdit} from "./LiveVideo/LiveVideoEdit";
import { Email} from "./mails/Email";
import {fetchUtils} from "react-admin";
import LiveTvIcon from '@material-ui/icons/LiveTv';
import EmailIcon from '@material-ui/icons/Email';
import EventIcon from '@material-ui/icons/Event';
const httpClient = fetchUtils.fetchJson;

const AdminPanel = () => {
  useEffect(() => {
    if (localStorage.getItem("is_authenticated") !== "true") {
      localStorage.setItem("is_authenticated", false);
    }
  }, []);
  return (
    <Admin dataProvider={DataProviders} authProvider={authProvider}>
      <Resource
        name="Events"
        list={EventList}
        show={EventDetails}
        create={EventCreate}
        icon={EventIcon}
      />
      <Resource name="EventResults" create={EventResultCreate} />
      <Resource name="EventBasketing" create={EventBasketingCreate} />
      <Resource
        name="LiveLookups"
        options={{ label: "Live" }}
        list={LiveVideoList}
        edit={LivelookupEdit}
        icon={LiveTvIcon}
      />
      <Resource name="tags" />

      <Resource name="Email" options={{ label: "Mails" }} list={Email} icon={EmailIcon} />
    </Admin>
  );
};
export { AdminPanel };